import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { ConfigurationClientService } from '../../services/client/configuration-client.service';

@Component({
  selector: 'app-header-toolbar',
  imports: [
    CommonModule,
    MatIcon,
    MatToolbar,
    MatIconButton,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuModule,
    MatDivider
  ],
  templateUrl: './header-toolbar.component.html',
  styleUrl: './header-toolbar.component.scss',
})
export class HeaderToolbarComponent {
  @Input() heading!: string | null;
  @Input() userEmail!: string | null;
  @Input() showSearch!: boolean;
  @Input() showNotifications!: boolean;
  @Output() toggleSidenav = new EventEmitter<void>();
  logoUrl = '';
  @Input() appHeading: string | undefined;
  menuOpen = false;
  userRole: string | null = null;

  constructor(
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private router: Router,
    private config: ConfigurationClientService
  ) { }

  showComingSoonMessage(verticalPosition: 'top' | 'bottom' = 'top') {
    this.snackBar.open('Coming soon!', 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: verticalPosition,
    });
  }

  logout() {
    this.authService.signOut().then(() => {
      this.router.navigate(['/login']);
    });
  }

  navigateToProfile() {
    this.router.navigate(['/profile']);
  }

  navigateToWorkspace() {
    this.router.navigate(['/workspaces']);
  }

  onToggleSidenav() {
    this.toggleSidenav.emit();
  }

  ngOnInit(): void {
    // Set default values only if inputs are not provided
    if (!this.appHeading) {
      this.appHeading = this.config.getSetting('general', 'appHeading');
    }
    this.logoUrl = this.config.getSetting('general', 'logoUrlLight');

    // Get user role from auth service if available
    this.authService.getUserProfile().subscribe(profile => {
      if (profile?.roles && profile.roles.length > 0) {
        // Take the first role if multiple roles exist
        this.userRole = this.formatRole(profile.roles[profile.roles.length - 1]);
      }
    });
  }

  private formatRole(role: string): string {
    // Format role for display (e.g., "admin" -> "Admin", "super_admin" -> "Super Admin")
    return role
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
